exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.signup__form[data-v-691fb4a1] {\n  width: 45vh;\n}\n", "", {"version":3,"sources":["/var/www/appv1.carnet-info-logement.com/src/containers/change-email-verification/styles.scss"],"names":[],"mappings":";AAIE;EACE,YAAW;CACZ","file":"styles.scss","sourcesContent":["$primary:#2E038C;\n$white:white;\n\n.signup {\n  &__form {\n    width: 45vh;\n  }\n}"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-691fb4a1","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./src/containers/change-email-verification/styles.scss
// module id = N8KL
// module chunks = 0